import { User } from '@genesislcap/foundation-user';
import { customElement, GenesisElement, observable } from '@genesislcap/web-core';
import { AppManagementStyles as styles } from './app-management.styles';
import { AppManagementTemplate as template } from './app-management.template';

@customElement({
  name: 'app-management-route',
  template,
  styles,
})
export class AppManagement extends GenesisElement {
  @User user: User;
  @observable selectedWatchlistId: string | null = null;
  @observable watchListSelectedBonds: any[] = [];

  constructor() {
    super();
  }

  handleWatchlistSelected = (event) => {
    this.selectedWatchlistId = event.detail;
  };

  handleAddWatchlist = (event) => {
    this.watchListSelectedBonds = event.detail;
  };
}
